/** 
*@author: satyamurthy.a
*@Description : 
**/
import { connect } from 'react-redux';
import { Popconfirm, Input,Button,Tooltip } from 'antd';
import ListView from '../../../Utils/ListView';
import Highlighter from 'react-highlight-words';
import { encode as base64_encode } from 'base-64';
import { constant } from '../../../Utils/constants';
import React, { useState, useEffect, useRef } from 'react';
import { API_MASTERTOOL } from '../../../../../commons/api';
import translation from '../../../../../commons/translation';

import {
  DeleteOutlined,
  EditOutlined,
  QuestionCircleOutlined,
  SearchOutlined
} from '@ant-design/icons';
import {
  getMasterList,
  deleteMaster
} from '../../../Utils/FormCalls';

const urlList = {
  list: API_MASTERTOOL.LIST,
  delete: API_MASTERTOOL.DELETE
};

const ToolsList = (props) => {
  const [dataSource, setDataSource] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [translationCache, setTranslationCache] = useState(props.translationCache || []);

  const searchInput = useRef(null);

  const config = {
    title: translation(translationCache, 'Tool'),
    viewTypes: ['add', 'card', 'table'],
    defaultViewType: 'table',
    filterType: 'ByAttributeValue',
    attributeList: ['Tool'],
    firstTitle: 'Tool',
    secondTitle: 'CreatedBy',
    thirdTitle: 'CreatedTime',
    actions: ['edit', 'delete'],
    edit: {
      byAttribute: 'Id',
      redirectURL: '/rubus/AMM/ToolsDetails'
    },
    deletee: {
      byAttribute: 'Id'
    }
  };

  useEffect(() => {
    setTranslationCache(props.translationCache);
  }, [props.translationCache]);

  useEffect(() => {
    const fetchData = async () => {
      const dataSource = await getMasterList(urlList.list);
      setDataSource(dataSource);
    };
    fetchData();
  }, []);

  const _editRecord = (record) => {
    props.navigate({ pathname: `${config.edit.redirectURL}/${base64_encode(record.Id)}` });
  };

  const _deleteById = async (id) => {
    await deleteMaster(urlList.delete, id);
    const dataSource = await getMasterList(urlList.list);
    setDataSource(dataSource);
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={translation(props.translationCache, `Search ${dataIndex}`)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          
          style={{ width: 90, marginRight: 8 }}
        >
          {translation(props.translationCache, constant.search)}
        </Button>
        <Button
          danger
          onClick={() => handleReset(clearFilters, confirm)}
          
          style={{ width: 90 }}
        >
          {translation(props.translationCache, constant.reset)}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      record &&
      record[dataIndex] &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };

  const columns = [
    {
      title: translation(translationCache, constant.tool),
      dataIndex: 'Tool',
      key: 'Tool',
      filter: true,
      ...getColumnSearchProps('Tool')
    },
    {
      title: translation(translationCache, constant.description),
      dataIndex: 'Description',
      key: 'Description',
      ...getColumnSearchProps('Description')
    },
    {
      title: translation(translationCache, constant.storeLocation),
      dataIndex: 'StoreLocation',
      key: 'StoreLocation',
      filter: true
    },
    {
      title: translation(translationCache, constant.action),
      width: '600',
      render: (text, record) => (
        <>
          <Button style={{ marginRight: "10px" }} onClick={() => _editRecord(record)}>
            <Tooltip title={translation(translationCache, 'Edit')}>
              <EditOutlined />
            </Tooltip>
          </Button>
          <Popconfirm
            title={translation(translationCache, constant.deleteToolMaster)}
            icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
            onConfirm={() => _deleteById(record.Id)}
            okText={translation(translationCache, constant.yes)}
            cancelText={translation(translationCache, constant.no)}
          >
            <Button >
              <Tooltip title={translation(translationCache, 'Delete')}>
                <DeleteOutlined />
              </Tooltip>
            </Button>
          </Popconfirm>
        </>
      )
    }
  ];

  return (
    <>
      <ListView
        {...props}
        columns={columns}
        dataSource={dataSource}
        config={config}
        delete={_deleteById}
      />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
    userProfile: state.LayoutReducer.userProfile,
  };
};

export default connect(mapStateToProps)(ToolsList);